import { useLeafletContext } from './core';
import { useEffect } from 'react';
import type { LeafletEventHandlerFnMap, Map } from '@anlan/gs-map';

export function useMap() {
    return useLeafletContext().map;
}
export function useMapEvent<T extends Extract<keyof LeafletEventHandlerFnMap, string>>(type: T, handler: LeafletEventHandlerFnMap[T]): Map {
    const map = useMap();
    useEffect(function addMapEventHandler() {
        map.on(type, handler);
        return function removeMapEventHandler() {
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
export function useMapEvents(handlers: LeafletEventHandlerFnMap): Map {
    const map = useMap();
    useEffect(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}
